<template>
	<div class="d-flex flex-column video-container">
		<div title="Back">
			<img
				src="@/assets/img/back button.svg"
				alt=""
				@click="handleBack"
				class="backBtn"
			/>
		</div>
		<section class="video-player flex-shrink-0">
			<video
				class="video"
				ref="dashvideo"
				width="100%"
				height="100%"
				data-dashjs-player
				:options="playerOptions"
				autoplay="true"
				controls
			></video>
			<div class="videoWrapper">
				<div id="videoController" class="video-controller unselectable">
					<div class="seekContainer">
						<div id="seekbar" class="seekbar seekbar-complete control">
							<div
								id="seekbar-play"
								class="seekbar seekbar-play progress-bar"
							></div>
						</div>
						<span id="videoTime" class="time-display">00:00:00</span>
					</div>
					<div class="left-side-controls">
						<div
							id="playPauseBtn"
							class="btn-play-pause"
							title="Play/Pause"
							@click="castNotification()"
						>
							<span id="iconPlayPause" class="icon-play"></span>
						</div>
						<div title="Rewind">
							<span>
								<img
									src="@/assets/img/rewind.svg"
									alt=""
									@click="handleReplayPlay()"
									class="cursorPointer"
								/>
							</span>
						</div>
						<div title="Forward">
							<span
								><img
									src="@/assets/img/forward.svg"
									alt=""
									class="replayBtn cursorPointer"
									@click="handleForwardPlay()"
							/></span>
						</div>
						<div class="volumeContainer">
							<div class="range-slider">
								<input
									class="range-slider__range"
									type="range"
									id="volumebar"
									value="1"
									min="0"
									max="1"
									step=".01"
								/>
							</div>

							<div
								id="muteBtn"
								class="btn-mute control-icon-layout"
								title="Mute"
							>
								<span
									id="iconMute"
									class="icon-mute-off"
									@click="volumeSliderFill()"
								></span>
							</div>
						</div>

						<div title="Movie Name" class="videoNameWrapper">
							<p class="videoName cursorPointer">{{ currentVideoName }}</p>
						</div>
					</div>
					<div class="right-side-controls">
						<div>
							<div v-if="showqueryDetails" class="queryDetailContainer">
								<p>Something Wrong?Tell Us.</p>
							</div>
						</div>
						<div title="Query">
							<span>
								<img
									src="@/assets/img/helpoutline.svg"
									alt=""
									class="questionBtn cursorPointer"
									@click="queryDetails()"
								/>
							</span>
						</div>
						<div
							id="captionBtn"
							class="btn-caption control-icon-layout"
							title="Closed Caption"
						>
							<span class="icon-caption"></span>
						</div>

						<div>
							<div v-if="showSubtitleDetails" class="subtitleDetailContainer">
								<p>Subtitles and Multi-language</p>
								<p>Features are coming soon</p>
							</div>
						</div>
						<div title="Subtitles">
							<span>
								<img
									src="@/assets/img/subtitles-24px.svg"
									alt=""
									@click="subtitleDetails()"
									class="cursorPointer"
								/>
							</span>
						</div>
						<div>
							<div v-if="showCastDetails" class="castDetailContainer">
								<p>The Casting feature is coming soon</p>
							</div>
						</div>
						<div title="Cast">
							<img
								src="@/assets/img/cast.svg"
								alt=""
								@click="sendRemotePlayer()"
								class="cursorPointer"
								:class="{ 'gray-bg': isConnectedCastDevice() }"
							/>
						</div>

						<span id="videoDuration" class="duration-display">00:00:00</span>

						<div
							id="bitrateListBtn"
							class="control-icon-layout"
							title="Bitrate List"
						>
							<span>
								<img
									src="@/assets/img/settings.svg"
									alt=""
									@click="toggleBitrateMenu"
									class="cursorPointer"
								/>
							</span>
						</div>

						<div
							id="fullscreenBtn"
							class="btn-fullscreen control-icon-layout"
							title="Fullscreen"
						>
							<span class="icon-fullscreen-enter p-0 "></span>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
import videojs from "video.js";
import "dashjs";
import "videojs-contrib-dash";
import "dashjs/contrib/akamai/controlbar/controlbar.css";
import ControlBar from "@/assets/js/controlbar.js";
// import ControlBar from "../../../node_modules/dashjs/contrib/akamai/controlbar/ControlBar.js";
import { mpdParser } from "mpd-m3u8-to-json";
import axios from "axios";
import CashPaymentVue from "../payment/CashPayment.vue";
import Castjs from "@/assets/js/Cast.js";
export default {
	name: "DashVideo",
	props: ["protData", "vid", "playback", "customData"],
	data() {
		return {
			videoid: null,
			playerOptions: {
				muted: true,
				language: "en",
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [
					{
						type: "video/mp4",
					},
				],
				autoSwitchBitrate: {
					audio: true,
					video: false,
				},
			},
			videoDetails: null,
			currentVideoName: null,
			bitrateValues: [],
			selected: null,
			showBitrates: false,
			showCastDetails: false,
			showSubtitleDetails: false,
			showqueryDetails: false,
			player: null,
			selectedBitrate: null,
			settings: {
				fill: "#85b157",
				background: "#d7dcdf",
			},
			isPlaybackEnded: false,
			showCastVideoNotification: false,
			showCastingOn: false,
			lastPlayerSeekedTime:null
		};
	},
	beforeDestroy() {
		var DataToSend = {};
		DataToSend["video_id"] = this.videoid;
		DataToSend["status"] = 1;
		DataToSend["resumeTime"] = Math.trunc(this.player.time());
		if (this.isPlaybackEnded == false) {
			this.$store.dispatch("setResumeVideo", DataToSend).then(() => {
				this.$store.dispatch("getResumeVideo");
			});
			this.player = null;
		}
	},

	mounted() {
		var self = this;
		this.videoid = this.$route.params.vid;
		this.$store.commit("setLoader", true);
		window.scroll(0, 0);
		var video,
			player,
			url = this.playback;
		//"https://du2g3i3j7aaem.cloudfront.net/a676df31-5457-44e2-8a6f-18342bd97243/dash/WJH.mpd";
		video = this.$refs.dashvideo;
		this.player = dashjs.MediaPlayer().create();
		this.player.initialize(video, url, true);
		this.player.setProtectionData(this.protData);
		var controlbar = new ControlBar(this.player);
		dashjs.MediaPlayer.events.STREAM_ACTIVATED = "streamActivated";
		dashjs.MediaPlayer.events.STREAM_DEACTIVATED = "streamDeactivated";
		dashjs.MediaPlayer.events.BUFFER_LEVEL_UPDATED = "bufferLevelUpdated";

		controlbar.initialize();
		this.player.on("streamInitialized", () => {
			this.player.getBitrateInfoListFor(video);
			var bitrates = this.player.getTopBitrateInfoFor(video);
		});
		this.player.on("playbackEnded", () => {
			this.isPlaybackEnded = true;
			var DataToSend = {};
			DataToSend["video_id"] = this.videoid;
			DataToSend["status"] = 0;
			DataToSend["resumeTime"] = 0;

			this.$store.dispatch("setResumeVideo", DataToSend);
			this.$router.go(-1);
		});
		this.player.on("playbackPlaying", () => {
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.play();
			}
		});
		this.player.on("playbackPaused", (event) => {
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.pause();
			}
		});
		this.player.on("playbackSeeked", () => {
			let playerCurrentTime = Math.trunc(this.player.time());
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.seek(playerCurrentTime);
			}
		});
		let vdEle = this.player.getVideoElement();
		vdEle.addEventListener("volumechange", () => {
			let playerCurrentVolumeTime = vdEle.volume;
			if (vdEle.muted) {
				let cjs = this.$store.getters.getCjs;
				if (cjs != null) {
					cjs.mute();
				}
			}
			if (!vdEle.muted) {
				let cjs = this.$store.getters.getCjs;
				if (cjs != null) {
					cjs.unmute();
				}
			}
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.volume(playerCurrentVolumeTime);
			}
		});

		this.$store.commit("showdefaultFooter", false);

		if (this.player) {
			if (this.$route.query.resume == "true") {
				this.$store.dispatch("getResumeVideo").then((res) => {
					setTimeout(() => {
						const resumeVideo = res.resumeList.find(
							(element) => element.video_id === this.videoid
						);
						if (resumeVideo) {
							const seekTime = this.player.seek(resumeVideo.resumeTime);
						}

						self.$store.commit("setLoader", false);
					}, 1000);
				});
			} else {
				this.$store.commit("setLoader", false);
			}
		}

		this.$store.dispatch("getVideoById", this.$route.params.vid).then((res) => {
			this.videoDetails = res._embedded.collections[0];
			if (this.videoDetails) {
				this.currentVideoName = this.videoDetails.name;
			} else {
				this.currentVideoName = " ";
			}
		});
		//this.getVideoName()
		const settings = {
			fill: "#85b157",
			background: "#d7dcdf",
		};

		const sliders = document.querySelectorAll(".range-slider");

		Array.prototype.forEach.call(sliders, (slider) => {
			slider.querySelector("input").addEventListener("input", (event) => {
				this.applyFill(event.target);
			});
			this.applyFill(slider.querySelector("input"));
		});
		const isCastingOn = this.$store.getters.getIsCastingOn;
		if (isCastingOn) {
			this.loadDefaultCast();
		}
	},
	methods: {
		handleBack() {
			var DataToSend = {};
			DataToSend["video_id"] = this.videoid;
			DataToSend["status"] = 1;
			DataToSend["resumeTime"] = Math.trunc(this.player.time());
			if (this.isPlaybackEnded == false) {
				this.$store.dispatch("setResumeVideo", DataToSend).then(() => {
					this.$store.dispatch("getResumeVideo");
				});
			}

			this.player = null;
			document.exitFullscreen();
			history.back();
		},
		handleForwardPlay() {
			const currentTime = this.player.time();
			this.player.seek(currentTime + 10);
		},
		handleReplayPlay() {
			const currentTime = this.player.time();
			this.player.seek(currentTime - 10);
		},

		toggleBitrateMenu() {
			this.showBitrates = !this.showBitrates;
			this.showCastDetails = false;
			this.showSubtitleDetails = false;
			this.showqueryDetails = false;
		},
		castDetails() {
			this.showCastDetails = !this.showCastDetails;
			this.showBitrates = false;
			this.showSubtitleDetails = false;
			this.showqueryDetails = false;
			document.getElementById("bitrateMenu").classList.add("hide");
		},
		subtitleDetails() {
			this.showSubtitleDetails = !this.showSubtitleDetails;
			this.showBitrates = false;
			this.showCastDetails = false;
			this.showqueryDetails = false;
			document.getElementById("bitrateMenu").classList.add("hide");
		},
		queryDetails() {
			this.showqueryDetails = !this.showqueryDetails;
			this.showBitrates = false;
			this.showCastDetails = false;
			this.showSubtitleDetails = false;
			document.getElementById("bitrateMenu").classList.add("hide");
		},
		volumeSliderFill() {
			setTimeout(() => {
				this.applyFill(document.querySelector("#volumebar"));
			}, 100);
		},
		applyFill(slider) {
			const percentage = 100 * parseFloat(slider.value);
			const bg = `linear-gradient(90deg, ${
				this.settings.fill
			} ${percentage}%, ${this.settings.background} ${percentage + 0.1}%)`;
			slider.style.background = bg;
		},
		sendRemotePlayer() {
			let cjs = this.$store.getters.getCjs;
			if (cjs == null) {
				cjs = new Castjs({
					receiver: "3726E1B7",
				});
				this.$store.commit("setCjs", cjs);
			}
			cjs.on("connect", () => {
				this.$store.commit("setNotification", `Connected to ${cjs.device}`);
				this.$store.commit("setIsCastingOn", true);
				this.showCastingOn = true;
				this.player.pause();
				this.showCastVideoNotification = true;
			});
			if (cjs.available) {
				cjs.cast(this.playback, {}, { licenseHeader: this.customData });
			}
			cjs.on("playing", () => {
				let playerCurrentTime = Math.trunc(this.player.time());
				if (cjs != null && this.lastPlayerSeekedTime != playerCurrentTime)  {
					this.lastPlayerSeekedTime = playerCurrentTime
					cjs.seek(playerCurrentTime);
				}
			});
			cjs.on("disconnect", () => {
				this.$store.commit(
					"setNotification",
					`DisConnected from ${cjs.device}`
				);
				this.lastPlayerSeekedTime = null;
				this.showCastingOn = false;
				this.$store.commit("setIsCastingOn", false);
				this.showCastVideoNotification = false;
			});
		},
		castNotification() {
			if (this.showCastVideoNotification) {
				this.$store.commit(
					"setNotification",
					"Video is also playing in cast device"
				);
			}
		},
		loadDefaultCast() {
			var mediaInfo = new chrome.cast.media.MediaInfo(this.playback);
			mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
			this.version = "v4.1.2";
			//	this.receiver = opt.receiver;
			//	this.joinpolicy = opt.joinpolicy;
			//	this.available = false;
			//this.connected = false;
			this.device = "Chromecast";
			this.src = "";
			this.title = "";
			this.description = "";
			this.poster = "";
			this.subtitles = [];
			this.volumeLevel = 1;
			this.muted = false;
			this.paused = false;
			this.time = 0;
			this.timePretty = "00:00:00";
			this.duration = 0;
			this.durationPretty = "00:00:00";
			this.progress = 0;
			//this.state = "disconnected";
			// This part is the reason why people love this library ❤️
			if (this.subtitles.length) {
				// I'm using the Netflix subtitle styling
				// chrome.cast.media.TextTrackFontGenericFamily.CASUAL
				// chrome.cast.media.TextTrackEdgeType.DROP_SHADOW
				mediaInfo.textTrackStyle = new chrome.cast.media.TextTrackStyle();
				mediaInfo.textTrackStyle.backgroundColor = "#00000000";
				mediaInfo.textTrackStyle.edgeColor = "#00000016";
				mediaInfo.textTrackStyle.edgeType = "DROP_SHADOW";
				mediaInfo.textTrackStyle.fontFamily = "CASUAL";
				mediaInfo.textTrackStyle.fontScale = 1.0;
				mediaInfo.textTrackStyle.foregroundColor = "#FFFFFF";

				var tracks = [];
				for (var i in this.subtitles) {
					// chrome.cast.media.TrackType.TEXT
					// chrome.cast.media.TextTrackType.CAPTIONS
					var track = new chrome.cast.media.Track(i, "TEXT");
					track.name = this.subtitles[i].label;
					track.subtype = "CAPTIONS";
					track.trackContentId = this.subtitles[i].src;
					track.trackContentType = "text/vtt";
					// This bug made me question life for a while
					track.trackId = parseInt(i);
					tracks.push(track);
				}
				mediaInfo.tracks = tracks;
			}
			// Let's prepare the metadata
			mediaInfo.metadata.images = [new chrome.cast.Image(this.poster)];
			mediaInfo.metadata.title = this.title;
			mediaInfo.metadata.subtitle = this.description;
			mediaInfo.customData = { licenseHeader: this.customData };
			// Prepare the actual request
			var request = new chrome.cast.media.LoadRequest(mediaInfo);
			cast.framework.CastContext.getInstance()
				.getCurrentSession()
				.loadMedia(request)
				.then(
					() => {
						// Update device name
						this.device =
							cast.framework.CastContext.getInstance()
								.getCurrentSession()
								.getCastDevice().friendlyName || this.device;
						return this;
					},
					(err) => {
						return this.trigger("error", err);
					}
				);
		},
		isConnectedCastDevice() {
			if (this.showCastingOn) {
				return true;
			} else {
				return false;
			}
		},
	},
};
</script>

<style lang="scss">
.videoWrapper {
	position: relative;
	height: 0;
}

.video-controller {
	display: flex;
	position: relative;
	justify-content: space-between;
	width: 100%;
	bottom: 86px;
	background-color: transparent;
}
.seekContainer {
	position: absolute;
	bottom: 52px;
	width: 98%;
	display: flex;
	align-items: center;
	left: 16px;
	right: 8px;
	cursor: pointer;
}

.seekContainer input[type="range"i] {
	appearance: auto;
	cursor: default;
	padding: initial;
	border: initial;
	margin: 2px;
	height: 2px;
	flex: 1;
	&:focus {
		box-shadow: none !important;
	}
}
.right-side-controls {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-width: 300px;
}
.left-side-controls {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-width: 290px;
}

.duration-display {
	display: none;
}
.qualityText {
	margin-bottom: 20px !important;
}

#bitrateMenu {
	bottom: 44px;
	top: inherit !important;
}
.icon-play,
.icon-pause,
.icon-caption,
.icon-mute-off,
.icon-mute-on,
.icon-fullscreen-enter,
.icon-fullscreen-exit,
.icon-tracks,
.icon-bitrate {
	font-family: "icomoon";
	font-size: 25px;
	color: white;
	text-shadow: none;
	-webkit-font-smoothing: antialiased;
	cursor: pointer;
	&:hover {
		transform: scale(1.1);
	}
}
.videoName {
	font: normal normal normal 22px/31px Averta-Regular;
	letter-spacing: 0px;
	color: #f1f2f2;
	opacity: 1;
	font-size: 14px;
	&:hover {
		transform: scale(1.1);
	}
}
.videoNameWrapper {
	margin-top: 15px;
}

.castDetailContainer {
	border-radius: 5px;
	position: absolute;
	right: 42px;
	color: #f1f2f2;
	width: 350px;
	height: 70px;
	background: #8a8a8a80 no-repeat padding-box;
	opacity: 1;
	bottom: 65px;
	border: #f1f2f2 1px solid;
	padding: 20px;
	border-radius: 5px;
	text-align: center;
	line-height: 8px;
}
.subtitleDetailContainer {
	border-radius: 5px;
	position: absolute;
	right: 70px;
	color: #f1f2f2;
	width: 260px;
	height: 70px;
	background: #8a8a8a80 no-repeat padding-box;
	opacity: 1;
	bottom: 65px;
	border: #f1f2f2 1px solid;
	padding: 20px;
	border-radius: 5px;
	text-align: center;
	line-height: 8px;
}
.queryDetailContainer {
	border-radius: 5px;
	position: absolute;
	right: 150px;
	color: #f1f2f2;
	width: 240px;
	height: 50px;
	background: #8a8a8a80 no-repeat padding-box;
	opacity: 1;
	bottom: 65px;
	border: #f1f2f2 1px solid;
	padding: 20px;
	border-radius: 5px;
	text-align: center;
	line-height: 8px;
}
.fa-arrow-left:before {
	content: "\f060";
	color: white;
	font-size: 31px;
}
.backBtn {
	position: fixed;
	transform: translate(60%, 150%);
	z-index: 200;
	color: white !important;
	background-color: none;
	cursor: pointer;
	background: transparent;
	display: flex !important;
	justify-content: center !important;
	width: 27px;
	margin-top: 10px;
}

.video-controller img {
	width: 25px;

	&:hover {
		transform: scale(1.1);
	}
}
.tickmark {
	position: absolute;
	left: 33px !important;
}
.seekContainer {
	overflow: inherit;
}
.seekContainer input[type="range"] {
	appearance: none;
	-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
	height: 10px;
	border: none;
	margin: 12px 5px;
	padding: 1px 2px;
	border-radius: 5px;
	background: white;
	box-shadow: inset 0 1px 0 0 #0d0e0f, inset 0 -1px 0 0 #3a3d42;
	-webkit-box-shadow: inset 0 1px 0 0 #0d0e0f, inset 0 -1px 0 0 #3a3d42;
	outline: none; /* no focus outline */
}
input[type="range"]::-webkit-slider-thumb {
	-webkit-appearance: none;
	width: 15px;
	height: 15px;
	border: none;
	border-radius: 50%;
	background-color: #85b157;
}
input[type="range"]::-moz-range-thumb {
	-webkit-appearance: none;
	width: 15px;
	height: 15px;
	border: none;
	border-radius: 50%;
	background-color: #85b157;
}

input[type="range"]::-ms-thumb {
	-webkit-appearance: none;
	width: 15px;
	height: 15px;
	border: none;
	border-radius: 50%;
	background-color: #85b157 !important;
}

.seekContainer .seekbar-complete {
	width: 100%;
	height: 7px;
	margin-top: 0px !important;
	background: #f9f9f9;
	position: relative;
	overflow: visible;
	border-radius: 10px;
}
.seekbar-play {
	left: 0px;
	top: 0px;
	padding: 5px;
	width: 0%;
	height: 9px !important;
	background: #679f3d;
	cursor: pointer;
}
.control .progress-bar::after {
	position: absolute;
	content: "";
	width: 10px;
	height: 10px;
	background: #679f3d;
	display: inline-block;
	right: 0;
	border-radius: 10px;
	padding: 10px;
}
.control .progress-bar {
	position: relative;
	overflow: visible;
	background-color: #679f3d;
}
#bitrateMenu {
	bottom: 62px;
	right: 58px !important;
}
.menu {
	position: absolute;

	color: #f1f2f2;
	width: 150px;
	height: auto;
	background: #8a8a8a80;
	opacity: 1;
	border: #f1f2f2 1px solid;
	padding: 20px;
	border-radius: 5px;
	text-align: left;
	line-height: 26px;
	letter-spacing: 0;
}

.menu-item-unselected {
	font-weight: normal;
	font-size: 0.9em;
	font-family: "averta-regular";
	color: #f1f2f2;
}
.menu-item-selected {
	background: none !important;
}
.menu-item-unselected,
.menu-item-selected {
	font-weight: normal;
	font-size: 0.9em;
	font-family: "averta-regular";
	color: #f1f2f2;
}

.menu-item-over,
.menu-item-selected {
	color: none;
	background: none !important;
}
.menu-item-selected:before {
	content: "\2713";
	display: inline-block;
	vertical-align: middle;
	line-height: 1em;
	width: auto;
	height: auto;
	margin-right: 0.3em;
	text-align: center;
	font-weight: bold;
	color: #f1f2f2;
}
.menu-sub-menu-title {
	background-color: #8a8a8a80 !important;
	color: #f1f2f2;
	font-weight: bold;
	text-align: left;
	font-size: 1em;
	font-family: "averta-regular";
	border: none;
}
#bitrateMenu .menu-sub-menu-title {
	min-width: 100px !important;
}
.cursorPointer {
	cursor: pointer;
}
.hideMenu {
	display: none;
}

input[type="range"] {
	height: 4px;
	border: none;
	background: #f9f9f9;
	box-shadow: none;
	-webkit-box-shadow: none;
	display: none;
	border-radius: 10px;
	padding: 0px 0px;
}
input[type="range"]:focus {
	border-color: #679f3d !important;
	box-shadow: none !important;
}
input[type="range"]::-webkit-slider-thumb {
	background: #679f3d;
}
.btn-mute {
	position: relative;
}
.volumeContainer:hover input[type="range"] {
	display: block;
}
.volumeContainer {
	position: relative;
}
#volumebar:hover {
	display: block;
}
.range-slider {
	width: 70px;
	transform: rotate(-90deg);
	position: absolute;
	bottom: 65px !important;
	left: -15px !important;
}

.range-slider__range {
	-webkit-appearance: none;
	width: 70px;
	height: 10px;
	border-radius: 5px;
	background: #d7dcdf;
	outline: none;
	padding: 0;
	margin: 0;

	&::-webkit-slider-thumb {
		appearance: none;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #679f3d;
		cursor: pointer;

		&:hover {
			background: #679f3d;
		}
	}

	&:active::-webkit-slider-thumb {
		background: #679f3d;
	}

	&::-moz-range-thumb {
		width: 20px;
		height: 20px;
		border: 0;
		border-radius: 50%;
		background: #679f3d;
		cursor: pointer;
	}

	&:active::-moz-range-thumb {
		background: #679f3d;
	}
}
.icon-fullscreen-enter {
	background: url("../../assets/img/fullscreen.svg");
	width: 25px;
	height: 22px;
	display: inline-block;
	background-repeat: no-repeat;
	background-size: 25px;
	&:hover {
		transform: scale(1.1);
	}
}
.icon-fullscreen-enter:before {
	content: "";
}
.icon-fullscreen-exit:before {
	content: "";
}
.icon-fullscreen-exit {
	background: url("../../assets/img/full-screen-exit.png");
	width: 25px;
	height: 25px;
	display: inline-block;
	background-repeat: no-repeat;
	background-size: 23px;
	&:hover {
		transform: scale(1.1);
	}
}

.btn-fullscreen {
	margin-top: 10px;
	padding-right: 25px;
}
video {
	max-height: 100vh;
	object-fit: cover;
}
.btn-play-pause {
	&:hover {
		transform: scale(1.1);
	}
}
#muteBtn {
	&:hover {
		transform: scale(1.1);
	}
}
.gray-bg {
	background-color: gray;
}
</style>
